// extracted by mini-css-extract-plugin
module.exports = {"body":"styles__body--3-qvX","actions":"styles__actions--3lBuN"};